import React from "react";
import Modal from "react-responsive-modal";

const styles = {
  modalWrapper: {
    width: "100%",
    paddingVertical: "15px",
    height: "100%",
    maxHeight: "85vh",
    overflowY: "scroll",
  },
  title: {
    textAlign: "center",
    marginTop: "20px",
    color: "#1679c7",
  },

  modalLoading: {
    fontWeight: 400,
    backgroundColor: "white",
    display: "flex",
    position: "fixed",
    padding: 8,
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    color: "#1679c7",
    animationName: "spinStaggered",
    animationDuration: "1200ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
  },

  "@keyframes spinStaggered": {
    "0%": {
      transform: "rotate(0deg)",
    },

    "65%": {
      transform: "rotate(350deg)",
    },

    "100%": {
      transform: "rotate(360deg)",
    },
  },
};

export default class BaseModal extends React.Component {
  render() {
    const { title } = this.props;

    return (
      // focus trap disables setting focus on text boxes. You can set it back to true on
      // MODALS WITH FORMS ONLY, that is, a focuseable element. Otherwise things will break
      <Modal showCloseIcon={false} focusTrapped={false} {...this.props}>
        <div style={styles.modalWrapper}>
          {this.props.loading && (
            <div style={styles.modalLoading} className="modalLoadingShadow">
              <i className="fas fa-asterisk" />
            </div>
          )}

          {title && <h3 style={styles.title}>{title}</h3>}
          {this.props.children}
        </div>
      </Modal>
    );
  }
}
